export default __webpack_public_path__ + "assets/icons/mail.317e980b.svg";